import React from 'react'
import PropTypes from 'prop-types'

const FeedbackAction = ({ feedback }) => {
  const { message, success } = feedback

  return (
    message
      ? (
        <div className={success ? 'shpmtc-input__success-msg success-message' : 'shpmtc-input__error-msg error-message'}>
          {message}
        </div>
      )
      : null
  )
}

FeedbackAction.propTypes = {
  feedback: PropTypes.shape({
    message: PropTypes.string,
    success: PropTypes.bool,
  }).isRequired,
}

export default FeedbackAction
